(() => {
  function revealActive(container) {
    container.querySelectorAll('.lb-customer-service-tabs__nav').forEach((nav) => {
      const active = nav.querySelector('[aria-current="page"]');
      if (!active) return;
      nav.scrollLeft = active.offsetLeft - nav.offsetLeft - (nav.clientWidth - active.clientWidth) / 2;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => revealActive(document), { once: true });
  } else {
    revealActive(document);
  }
  document.addEventListener('shopify:section:load', (event) => revealActive(event.target));
})();
